import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';
import _ from 'lodash';

import { api } from '@/api';
import { INVESTMENT_TRADING_SUMMARY } from '@/common/paths';

const BASE_COUNT = 0.125;
const ONE_VALUES_COINS = _.round(1 / BASE_COUNT, 0);
const MAX_VALUES = ONE_VALUES_COINS * 5;

const QUERY_KEY = 'GET_TRADING_SUMMARY';

const DEFAULT_BALANCE = ONE_VALUES_COINS * 2;
const useGetTradingSummaryQuery = () => {
  const { isLoading, data, isSuccess } = useQuery([QUERY_KEY], () => api.get(INVESTMENT_TRADING_SUMMARY));
  const formattedData = useMemo(() => {
    return {
      deposit: data?.data?.deposit_amount || 0,
      withdraw: data?.data?.withdrawal_amount || 0,
    };
  }, [data?.data?.deposit_amount, data?.data?.withdrawal_amount]);

  const counts = useMemo(() => {
    const first = formattedData.deposit;
    const second = formattedData.withdraw;
    if (!second || second < 0) {
      return {
        deposit: ONE_VALUES_COINS,
        widthdraw: 0,
      };
    }
    const base = second / first;
    const widthdraw = !_.isFinite(base)
      ? MAX_VALUES
      : _.isNaN(base)
        ? DEFAULT_BALANCE
        : _.ceil(ONE_VALUES_COINS * base, 0) || 0;

    return {
      deposit: ONE_VALUES_COINS,
      widthdraw: _.min([widthdraw, MAX_VALUES]),
    };
  }, [formattedData]);

  return {
    data: formattedData,
    counts,
    isSuccess,
    isLoading,
  };
};
export default useGetTradingSummaryQuery;
